import React from 'react';

const GROUPS = [
    {
        tone: 'white', title: 'For Applicants', who: 'Every company who applies, before acceptance',
        cards: [
            { tag: 'free', label: 'Free', title: 'Investment Readiness Check', body: 'A 30-minute bespoke module, no commitment required.' },
            { tag: 'free', label: 'Free', title: 'Pitch Deck Analyser', body: 'Suggested diligence focus areas, generated automatically.' },
            { tag: 'rev', label: 'Reverse Diligence', title: 'AI CEO Stress Test', body: 'Reverse-engineers the business case to find its own quick wins first.' },
            { tag: 'rev', label: 'Reverse Diligence', title: 'Research Aid', body: 'A set of research reports on market and opportunity.' },
        ],
    },
    {
        tone: 'lite', title: 'For Accepted Cohort', who: 'Onboarded into the programme, building the pack',
        cards: [
            { tag: 'lite', label: 'Pro', title: 'Complete Diligence Pack', body: '~60% auto-filled by Clarence from upload or cloud ingestion.' },
            { tag: 'rev', label: 'Reverse Diligence', title: 'Corporate & Legal DD', body: "Use Diligentsia's tools or connect your own advisors via MCP." },
            { tag: 'rev', label: 'Reverse Diligence', title: 'Financial Model', body: 'Creation and reverse diligence, scored against a consistent standard.' },
            { tag: 'rev', label: 'Reverse Diligence', title: 'Technical DD', body: 'Full software due diligence, without extracting source code.' },
        ],
    },
];

const LEGEND = [
    { sw: 'free', label: 'Free' },
    { sw: 'lite', label: 'Included in Pro' },
    { sw: 'rev', label: 'Reverse diligence' },
];

const AccCohortModulesSection = () => (
    <section className="lp-acc-sec lp-acc-sec--lavender">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>The platform, module by module</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">Every module built for you, from application to funding.</h2>
            <p className="lp-acc-sub" data-lp-reveal data-lp-delay="120">Free triage while you apply. Reverse-diligence tools once you're accepted — so by demo day, nothing in your data room is a surprise, even to you.</p>

            <div className="lp-acc-modules" data-lp-reveal data-lp-delay="160">
                <div className="lp-acc-mod-legend">
                    {LEGEND.map(l => (
                        <div className="lg-item" key={l.label}><span className={`lg-swatch is-${l.sw}`} />{l.label}</div>
                    ))}
                </div>

                <div className="lp-acc-mod-groups is-double">
                    {GROUPS.map(g => (
                        <div className={`lp-acc-mod-group is-${g.tone}`} key={g.title}>
                            <div className="lp-acc-mod-group-head"><h3>{g.title}</h3></div>
                            <div className="lp-acc-mod-who">{g.who}</div>
                            {g.cards.map(c => (
                                <div className="lp-acc-mod-card" key={c.title}>
                                    <span className={`lp-acc-mod-tag is-${c.tag}`}>{c.label}</span>
                                    <h4>{c.title}</h4>
                                    <p>{c.body}</p>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                <div className="lp-acc-mod-timeline" data-lp-reveal>
                    <span>Weeks, unprepared</span>
                    <span className="arrow-long">→</span>
                    <span className="pill">Days, with a certified pack</span>
                </div>
            </div>
        </div>
    </section>
);

export default AccCohortModulesSection;
